import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useCallback } from 'react';

interface IRouteTimeSelectorProps {
  value: number;
  onChange: (n: number) => void;
}

const RouteTimeSelector = (props: IRouteTimeSelectorProps) => {
  const onChange = useCallback(
    ({ target: { value } }: any) => props.onChange(parseInt(value)),
    [props.onChange],
  );
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="time-label">Tiempo de ruta</InputLabel>
      <Select
        labelId="time-label"
        label="Tiempo de ruta"
        onChange={onChange}
        value={props.value}
      >
        <MenuItem value={4}>04:00:00</MenuItem>
        <MenuItem value={5}>05:00:00</MenuItem>
        <MenuItem value={6}>06:00:00</MenuItem>
        <MenuItem value={7}>07:00:00</MenuItem>
        <MenuItem value={8}>08:00:00</MenuItem>
        <MenuItem value={9}>09:00:00</MenuItem>
        <MenuItem value={10}>10:00:00</MenuItem>
        <MenuItem value={11}>11:00:00</MenuItem>
        <MenuItem value={12}>12:00:00</MenuItem>
      </Select>
    </FormControl>
  );
};

export default RouteTimeSelector;
